import { useNavigate, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { faHomeLgAlt } from '@fortawesome/pro-solid-svg-icons';
import { translate } from '../../translations/translator';
const t = key => translate('worksheet', key);

const WorksheetMakerHeader = () => {
  const classes = useStyles();
  const { container, menuBar, menuButton, menuIcon, title } = classes;
  const navigate = useNavigate();
  const location = useLocation();

  const goHome = () => navigate(`/0${location.search}`);

  return (
    <Box className={container} displayPrint={'none'}>
      <Box className={menuBar}>
        <Box className={menuButton}>
          <FontAwesomeIcon icon={faBars} className={menuIcon} />
        </Box>
        <Box className={menuButton} onClick={goHome}>
          <FontAwesomeIcon icon={faHomeLgAlt} className={menuIcon} />
        </Box>
        <Box className={title}>{t('title')}</Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles({
  container: {},
  menuBar: {
    display: 'flex',
    backgroundColor: '#2671ba',
    color: 'white',
    fontSize: '20px',
    fontFamily: 'Futura-Semibold',
    height: '60px',
    borderBottom: '.5px solid #295682'
  },
  menuButton: {
    cursor: 'pointer',
    borderRight: '1px solid black'
  },
  menuIcon: {
    margin: '10px',
    marginTop: '22px'
  },
  title: {
    margin: '10px',
    paddingTop: '5px',
    fontSize: '25px'
  }
});

export default WorksheetMakerHeader;
